import { Info } from "lucide-react";
import { TouchTooltip } from "@/components/ui/touch-tooltip";

type FieldTooltipProps = {
  content: string;
};

function FieldTooltip({ content }: FieldTooltipProps) {
  return (
    <TouchTooltip content={content} className="max-w-xs text-xs">
      <Info className="inline-block w-3.5 h-3.5 text-ds-text-400 hover:text-ds-text-600 cursor-help ml-1 shrink-0" />
    </TouchTooltip>
  );
}

export default FieldTooltip;
